import { config } from 'util/config';
import { httpClient } from "util/Api";
import * as globalFunction from 'util/GlobalFunction';

export function addFireSafetyMeasurePopUpRun({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  setTimeout(() => {
    //设置联动的Select
    getFireSafetyMeasureGroupSelectOptionList({ sectionName: sectionName, parameter: parameter, formComponent: sectionComponent.customForm.current, sectionComponent: sectionComponent, pageComponent: pageComponent });
  }, config.setTimeoutMilliSecond);
}

export function editFireSafetyMeasurePopUpRun({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  setTimeout(() => {
    //设置联动的Select
    getFireSafetyMeasureGroupSelectOptionList({ sectionName: sectionName, parameter: parameter, formComponent: sectionComponent.customForm.current, sectionComponent: sectionComponent, pageComponent: pageComponent });
  }, config.setTimeoutMilliSecond);
}

//获取 FireSafetyMeasureGroup 下拉列表
export function getFireSafetyMeasureGroupSelectOptionList({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  let jobId = pageComponent.state.jobData?.JobId || pageComponent.state.approvalData?.JobId;
  httpClient
    .get('Business/FireSafetyMeasureGroup/GetSelectOptionList?jobId=' + jobId)
    .then(({ data }) => {
      if (data.result) {
        let dataSource = data.data;
        let componentDataSource = { ...formComponent.state.componentDataSource };
        componentDataSource['GroupId'] = dataSource;
        formComponent.setState({ componentDataSource });
        //新增且未传入 GroupId 时, 默认选中首项 "- Select Group -"
        if (parameter.GroupId === undefined || parameter.GroupId === null) {
          sectionComponent.customForm.current?.formRef.current?.setFieldValue('GroupId', dataSource[0].Value);
        }
      } else {
        globalFunction.handleResultError(data, pageComponent);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
}

//打开从模板添加界面, parameter.GroupId 为 Group 级别点击时的当前 Group
export function addFromTemplate({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  let groupEnabled = sectionComponent?.props?.section?.type === 'FireSafetyMeasureTable';
  openAddFromTemplate({ component: pageComponent, parameter: parameter?.GroupId, groupEnabled: groupEnabled });
}

export function openAddFromTemplate({ component, parameter, groupEnabled } = {}) {
  component.setState({ fireSafetyMeasureAddFromTemplateShow: true });
  //parameter 为 undefined/null 且开启 Group 功能时, 才显示 Group 下拉
  let isSectionLevel = parameter === undefined || parameter === null;
  let showGroupSelect = isSectionLevel && groupEnabled === true;
  setTimeout(() => {
    component.fireSafetyMeasureAddFromTemplate.current?.setState({ defaultSelectedRowKeys: [], selectedRowKeys: [], groupId: parameter, showGroupSelect: showGroupSelect });
    setTimeout(() => {
      component.fireSafetyMeasureAddFromTemplate.current?.getFireSafetyMeasureTemplate();
      //需要显示 Group 下拉时, 加载 Group 下拉选项
      if (showGroupSelect) {
        component.fireSafetyMeasureAddFromTemplate.current?.getFireSafetyMeasureGroupSelectOptionList();
      }
    }, config.setTimeoutMilliSecond);
  }, config.setTimeoutMilliSecond);
}

//打开 Manage Group 弹窗
export function manageGroup({ sectionName, parameter, formComponent, sectionComponent, pageComponent, uie } = {}) {
  sectionComponent.child.current?.setState({ manageGroupShow: true });
  setTimeout(() => {
    sectionComponent.child.current?.manageGroup.current?.getFireSafetyMeasureGroupList();
  }, config.setTimeoutMilliSecond);
}

//从 Group 级别的 Add 按钮调用, 新增 FireSafetyMeasure 时预填当前 GroupId
export function addFireSafetyMeasure({ parameter, sectionComponent, pageComponent, sectionName, uie } = {}) {
  sectionComponent.setState({ showModal: true, componentType: 'Create' });
  setTimeout(() => {
    let formData = parameter;
    sectionComponent.customForm.current?.formRef.current?.setFieldsValue(formData);
    sectionComponent.customForm.current?.setState({ formData, currentDataKey: 0 });

    setTimeout(() => {
      //设置联动的Select
      getFireSafetyMeasureGroupSelectOptionList({ sectionName: sectionName, parameter: parameter, formComponent: sectionComponent.customForm.current, sectionComponent: sectionComponent, pageComponent: pageComponent });
    }, config.setTimeoutMilliSecond);
  }, config.setTimeoutMilliSecond);
}
